import { isOneOf } from 'utils/isOneOf';
import type { DeviceViewEdgeEntity } from '../deviceViewTypes';

export const isTargetGroupMemberNode = (
  deviceViewEntity: DeviceViewEdgeEntity,
): boolean => isOneOf(deviceViewEntity.targetType, 'phone', 'host');
